export default __webpack_public_path__ + "static/media/trailerSelected.7f166e76.svg";